import { createCachedSelector } from 're-reselect';
export function getTokens(state) {
    return state.tokens;
}
export function getTokenById(state, id) {
    return getTokens(state)[id] || null;
}
export var getTokensByType = createCachedSelector([getTokens, function (_state, type) { return type; }], function (tokens, type) {
    return Object.values(tokens).filter(function (token) { return token.type === type; });
})(function (_state, type) { return type; });
